<!-- eslint-disable -->
<template>
  <CommonPages id="loans" :class="['loans']" :titlePrefix="pageTitlePrefix"
    :metaDescription="domainConfig?.['meta']?.des || 'Default des'">
    <div class="loan-lenders"
      :class="[deviceType === 'mobile' ? 'detect_deviece_mobile' : 'detect_deviece_pc']">
      <div class="loan-lenders__header" :class="`design-${domainConfig?.['designType']}`">
        <h1 class="loan-lenders__title">Best Auto Loan Rates for Bad Credits</h1>
        <!-- <p class="loan-lenders__description">Explore competitive auto loan rates specifically
          designed for those with bad credit.</p> -->
        <div class="loan-lenders__divider"></div>
      </div>

      <!-- <AdComponent v-if="deviceType == 'mobile'"
        v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.all_1" ref="ads-all-1-2"
        class="ad-width-100 m_padding" :ads="adsensConfig?.all_1" :showDebug="showDebug" /> -->

      <div class="loan-lenders__content">
        <div class="credit-cards">
          <template v-for="(lender, index) in displayLenders">
            <div :key="index" class="credit-card">
              <div class="card-header">
                <div class="rating">
                  <img src="@/assets/icons/star.svg" alt="Rating" class="star-icon" />
                  <span>{{ lender.rating || (lender.rate ? parseFloat(lender.rate).toFixed(1) : '4.0') }}</span>
                </div>
                <div class="lender-name">{{ lender.name || lender.lender }}</div>
              </div>
              <div class="card-content">
                <div class="logo-container">
                  <img :src="lender.logoUrl" alt="Lender logo" class="lender-logo" />
                </div>
                <div class="divider" v-if="deviceType == 'mobile'"></div>
                <div class="lender-details-container">
                  <div class="detail-block">
                    <div class="detail-label">APR from</div>
                    <div class="detail-value">{{ lender.apr || lender.aprFrom }}</div>
                  </div>
                  <div class="divider"></div>
                  <div class="detail-block">
                    <div class="detail-label">Loan term</div>
                    <div class="detail-value">{{ lender.term || `${lender.loanTerm } mos` }}
                    </div>
                  </div>
                  <div class="divider"></div>
                  <div class="detail-block">
                    <div class="detail-label">Loan amount</div>
                    <div class="detail-value">
                      {{ lender.amount || `$${lender.loanAmount }` }}</div>
                  </div>
                  <div class="divider" v-if="deviceType == 'mobile'"></div>

                </div>
              </div>
              <a class="see-details-btn" @click="goToLenderDetails(lender)">
                <span>See Details</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12"
                  fill="none">
                  <path
                    d="M9.68066 0C9.83345 8.52298e-05 9.97979 0.0601591 10.0879 0.166707L16 6.00048L10.0879 11.8333C9.97979 11.9398 9.83345 11.9999 9.68066 12C9.52776 12 9.38064 11.9399 9.27246 11.8333L8.45703 11.0287C8.40356 10.976 8.36101 10.9135 8.33203 10.8446C8.30301 10.7756 8.2881 10.7016 8.28809 10.6268C8.28809 10.5521 8.30302 10.4781 8.33203 10.4091C8.36106 10.34 8.40341 10.2768 8.45703 10.224L11.583 7.14045H0.578125C0.424844 7.14045 0.277331 7.08069 0.168945 6.97374C0.0606338 6.8668 0 6.72118 0 6.56998V5.43002C0 5.27877 0.0605622 5.13321 0.168945 5.02626C0.277331 4.91931 0.424844 4.85955 0.578125 4.85955H11.582L8.45703 1.77596C8.34898 1.66922 8.28809 1.52404 8.28809 1.37316C8.28817 1.22248 8.34915 1.07799 8.45703 0.971332L9.27246 0.166707C9.38064 0.0600831 9.52776 0 9.68066 0Z"
                    fill="currentColor" />
                </svg>
              </a>
            </div>
            <!-- 插入广告 -->
            <div v-if="$global.isObjectNotEmpty(adsensConfig) && shouldInsertAd(index) !== -1"
              :key="`ad_${index}`" class="ad-width-100 ad-pos-row">
              <AdComponent v-if="adsensConfig?.all?.[shouldInsertAd(index)]"
                :ref="'ads-list2-' + index" class="recommand-ads"
                :ads="adsensConfig?.all[shouldInsertAd(index)]" :showDebug="showDebug" />
            </div>
          </template>
        </div>

      </div>
    </div>
  </CommonPages>
</template>

<script>
import common from '@/mixin/common.js'
import adMixin from '@/mixin/adMixin.js'
import adTrackingMixin from '@/mixin/adTrackingMixin.js'
import { mapGetters } from 'vuex';
import CommonPages from '@/pages/components/page_common.vue'
import AdComponent from '@/pages/components/AdComponent.vue'
import '@/css/home.scss';
import '@/css/common.scss';

export default {
  name: 'LendersForBadCredits',
  components: {
    CommonPages,
    AdComponent
  },
  mixins: [common, adMixin, adTrackingMixin],
  data () {
    return {
      lenders: []
    };
  },
  computed: {
    ...mapGetters([
      "adsensConfig",
      'adPosConfig',
      'deviceType',
      'domainConfig',
      'subprimeLendingInstitutions'
    ]),
    displayLenders () {
      // 如果有API返回的数据，优先使用，否则使用默认数据
      return this.subprimeLendingInstitutions && this.subprimeLendingInstitutions.length > 0
        ? this.subprimeLendingInstitutions
        : this.lenders
    },
    // 仅 carloan.techeasellc.com 使用文档指定的页面标题
    pageTitlePrefix () {
      if (this.domainConfig?.IAmURL === 'carloan.techeasellc.com') {
        return 'Auto Loan Rates for Bad Credits';
      }
      return 'Best Auto Loan Rates for Bad Credits';
    }
  },
  async activated () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[LendersForBadCredits] Component activated`);
    }
  },
  async mounted () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[LendersForBadCredits] Component mounted`);
    }
    await this.initAdSystem();
    // 确保在广告系统初始化后再初始化跟踪
    this.$nextTick(() => {
      this.initAdTracking();
    });
  },
  deactivated () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[LendersForBadCredits] Component deactivated`);
    }
  },
  beforeDestroy () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[LendersForBadCredits] Component beforeDestroy`);
    }
  },
  methods: {
    shouldInsertAd (index) {
      // 判断是否应该插入广告的位置
      const position = index + 1;
      const adIndex = this.deviceType == 'mobile' ? this.adPosConfig.listRecommand.indexOf(position) : this.adPosConfig.listRecommandPC.indexOf(position);

      /// 返回广告在 homeAD 中的索引，如果不在配置中则返回 -1
      return adIndex !== -1 ? adIndex : -1;
    },
    // 通用导航方法
    navigateToPage (path) {
      console.log(`navigateToPage: ${path}`);
      // 检查是否存在channel参数
      if (this.$route.params.channel) {
        // 如果有channel参数，使用完整路径
        this.$router.push(`/${this.$route.params.channel}${path}`);
      } else {
        // 如果没有channel参数，直接导航
        this.$router.push(path);
      }
    },
    goToLenderDetails (lender) {
      console.log((lender.name || lender.lender || '').toLowerCase());
      const lenderName = (lender.name || lender.lender || '').toLowerCase().replace(/\s+/g, '-');
      this.$router.push({
        name: 'LenderDetails',
        params: {
          lenderName: lenderName,
          id: lender.id || '1'
        }
      });
    },
  }
};
</script>

<style lang="scss" scoped>
@import '~@/css/variables.scss';

.loan-lenders {
	position: relative;
	padding-bottom: rem(120);

	&.detect_deviece_mobile {
		padding-bottom: rem(36);
	}

	&__header {
		display: flex;
		width: 100%;
		height: rem(200);
		flex-direction: column;
		align-items: center;
		margin-bottom: rem(40);
		text-align: center;
		gap: rem(20);
		justify-content: center;

		.detect_deviece_mobile & {
			margin-bottom: rem(30);
			padding: rem(42) rem(16);
			height: fit-content;
		}

		&.design-1 {
			background: url('~@/assets/auto-loan-bg.png') no-repeat center center;
			background-size: cover;
		}
		&.design-2 {
			background: url('~@/assets/auto-loan-bg-2.png') no-repeat center center;
			background-size: cover;
		}
		.detect_deviece_mobile & {
			&.design-1 {
				background: url('~@/assets/auto-loan-bg-m.png') no-repeat center center;
				background-size: cover;
			}
			&.design-2 {
				background: url('~@/assets/auto-loan-bg-m-2.png') no-repeat center center;
				background-size: cover;
			}
		}
	}

	&__title {
		color: #fff;
		font-size: rem(32);
		line-height: rem(36);
		font-weight: 900;

		.detect_deviece_mobile & {
			font-size: rem(24);
			line-height: rem(28);
			margin-bottom: rem(12);
		}
	}

	&__description {
		color: #fff;
		font-size: rem(16);
		line-height: rem(20);
		font-weight: 400;
		max-width: rem(700);

		.detect_deviece_mobile & {
			font-size: rem(14);
			line-height: rem(18);
			margin-bottom: rem(20);
		}
	}

	&__divider {
		width: rem(36);
		height: rem(4);
		background-color: #fff;
		border-radius: rem(100);
		background: #fff;
	}

	&__content {
		margin-top: rem(40);
		padding: 0 rem(120);

		.detect_deviece_mobile & {
			padding: 0 rem(16);
			margin-top: rem(20);
		}
	}
}

.credit-cards {
	display: flex;
	flex-direction: column;
	gap: rem(20);
}

.credit-card {
	background: linear-gradient(90deg, var(--theme-primary-light) 0%, rgba(255, 255, 255, 0) 50%, rgba(255, 255, 255, 0) 100%);
	border-radius: rem(24);
	border: rem(1) solid #e5e7eb;
	// transition: border 0.3s ease;
	position: relative;
	overflow: hidden;
	padding: rem(48) rem(36) rem(24) rem(36);

	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: rem(24);

	&:hover {
		border: rem(2) solid #1a4048;

		.see-details-btn {
			background-color: #1a4048;
			color: white;

			svg path {
				stroke: white;
			}
		}
	}

	.detect_deviece_mobile & {
		flex-direction: column;
		background: linear-gradient(180deg, var(--theme-primary-light) 0%, rgba(255, 255, 255, 0) 50%, rgba(255, 255, 255, 0) 100%);
		padding: rem(48) rem(16) rem(16) rem(16);
		gap: rem(16);
		align-items: flex-start;
	}
}

.card-header {
	display: flex;
	flex-direction: row;
	align-items: center;
	position: absolute;
	top: 0;
	left: 0;
}

.rating {
	display: flex;
	align-items: center;
	gap: rem(8);
	background: linear-gradient(270deg, rgba(218, 161, 13, 1) 0%, rgba(246, 195, 63, 1) 100%);
	border-radius: rem(24) 0 0 0;
	padding: 0 rem(16);
	height: rem(32);

	.star-icon {
		width: rem(12);
		height: rem(12);
	}
	span {
		color: white;
		font-size: rem(16);
		line-height: rem(16);
		font-weight: 900;
	}
}

.lender-name {
	color: #ffffff;
	font-size: rem(14);
	line-height: rem(16);
	font-weight: 800;
	background: #1a4048;
	border-radius: 0 0 rem(16) 0;
	padding: rem(8) rem(16);
	height: rem(32);
}

.card-content {
	padding: 0;
	display: flex;
	align-items: center;
	justify-content: space-between;

	.detect_deviece_mobile & {
		flex-direction: column;
		align-items: flex-start;
		width: 100%;
		gap: rem(16);
	}
}

.logo-container {
	width: rem(88);
	height: rem(88);
	border-radius: rem(20);
	background-color: white;
	border: rem(2) solid var(--theme-primary-light);
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	margin-right: rem(36);

	.detect_deviece_mobile & {
		margin-right: 0;
		width: rem(88);
		height: rem(88);
	}
}

.lender-logo {
	max-width: 80%;
	max-height: 80%;
	object-fit: contain;
}

.divider {
	width: rem(1);
	height: rem(52);
	background-color: #e5e7eb;
	margin: 0;

	.detect_deviece_mobile & {
		width: 100%;
		height: rem(1);
		margin: 0;
	}
}

.lender-details-container {
	display: flex;
	flex-direction: row;
	gap: rem(36);
	align-items: flex-start;
	flex-grow: 1;

	.detect_deviece_mobile & {
		flex-direction: column;
		width: 100%;
		gap: rem(24);
	}
}

.detail-block {
	display: flex;
	flex-direction: column;
	gap: rem(12);
	align-items: flex-start;
	width: rem(170);

	&:last-child {
		width: rem(260);
	}

	.detect_deviece_mobile & {
		width: 100%;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;

		&:last-child {
			width: 100%;
		}
	}
}

.detail-label {
	color: #1a4048;
	font-size: rem(14);
	line-height: rem(16);
	font-weight: 400;
}

.detail-value {
	color: #1a4048;
	font-size: rem(24);
	line-height: rem(24);
	font-weight: 700;
	&.detect_deviece_mobile {
		text-align: right;
	}
}

.card-footer {
	padding: 0;
	display: flex;
	justify-content: flex-end;
	border-top: none;
	position: static;
}

.user-avatar {
	position: absolute;
	right: rem(100);
	top: rem(-24);
	width: rem(48);
	height: rem(48);
	background-color: #4caf50;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	border: rem(2) solid white;
	overflow: hidden;
	z-index: 1;

	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
}

.see-details-btn {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: rem(12);
	padding: rem(12) rem(32);
	border-radius: rem(100);
	border: rem(1) solid #1a4048;
	background-color: white;
	color: #1a4048;
	font-size: rem(16);
	line-height: rem(16);
	font-weight: 700;
	text-decoration: none;
	transition: all 0.3s ease;
	height: rem(48);

	&:hover {
		background-color: #1a4048;
		color: white;

		svg path {
			stroke: white;
		}
	}

	svg {
		width: rem(16);
		height: rem(12);
	}

	.detect_deviece_mobile & {
		align-self: center;
		margin-top: rem(8);
	}
}

.view-all-container {
	display: flex;
	justify-content: center;
	margin-top: rem(40);
}

.view-all-btn {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: rem(8);
	padding: rem(12) rem(24);
	border-radius: rem(100);
	background-color: var(--theme-primary);
	color: white;
	font-size: rem(16);
	line-height: rem(20);
	font-weight: 700;
	text-decoration: none;
	transition: background-color 0.3s ease;

	&:hover {
		background-color: #00b8d9;
	}

	svg {
		width: rem(16);
		height: rem(16);
	}
}
</style>
